import { Grid } from "@material-ui/core";
import { SVG, Text } from "sunrise-ui";
import "./MachineCard.scss";

const MachineCard = (props: any) => {
  const { data, selected } = props;

  return (
    <Grid container xs={12}>
      <Grid
        style={{ width: "19rem" }}
        className={
          selected
            ? "box--shadow p1 mr-1 machine-card machine-card-selected"
            : "box--shadow p1 mr-1 machine-card"
        }
      >
        <Grid item xs={12}>
          <Grid container>
            <Grid className="card-box box--shadow p1" item xs={3}>
              <span>
                <SVG type={"pile"} />
              </span>
            </Grid>
            <Grid item xs={6}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={14}
                className="card-text mb1 mt15 center fw500"
              >
                {data.machineDetail}
              </Text>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Text
            type="normal"
            fonts="normal"
            fontSize={14}
            className="card-text mb1 mt0 fw400"
          >
            <span>Average Diesel consumption/Hr</span>
            <span className="ms1 float-right fw500">
              {data.avgDieselConsumption}
            </span>
          </Text>
          <Text
            type="normal"
            fonts="normal"
            fontSize={14}
            className="card-text mb1 mt0 fw400"
          >
            <span>Average Running Hrs per Day</span>
            <span className="ms1 float-right fw500">
              {data.avgRunningHoursPerDay}
            </span>
          </Text>
          <Text
            type="normal"
            fonts="normal"
            fontSize={14}
            className="card-text mb1 mt0 fw400"
          >
            <span>Own/Hired</span>
            <span className="ms1 float-right fw500">
              {data.ownership === "HIRED"
                ? data.ownership + "(" + data.ownerName + ")"
                : data.ownership}
            </span>
          </Text>
          <Text
            type="normal"
            fonts="normal"
            fontSize={14}
            className="card-text mb1 mt0 fw400"
          >
            <span>Current Status</span>
            <span
              className={
                data.currenStatus === "active"
                  ? "ms1 float-right fw500 text-active"
                  : data.currenStatus === "maintenance"
                  ? "ms1 float-right fw500 text-maintenance"
                  : data.currenStatus === "idle"
                  ? "ms1 float-right fw500 text-idle"
                  : "ms1 float-right fw500"
              }
              style={{ textTransform: "capitalize" }}
            >
              {data.currenStatus}
            </span>
          </Text>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MachineCard;
